module.exports = __webpack_public_path__ + "img/keyroom_logo.92b2d73e.svg";